import { render, staticRenderFns } from "./PackagesEditModal.vue?vue&type=template&id=e0a18d0e&scoped=true"
import script from "./PackagesEditModal.vue?vue&type=script&lang=js"
export * from "./PackagesEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a18d0e",
  null
  
)

export default component.exports